import { BottomSheet, Flex, Image, Shape, styled } from '@teko/ds-mobile';
import { MODE_TERMINAL_PICKER, useDistanceTerminalContext } from 'contexts';
import { t } from 'i18n';
import React, { useEffect } from 'react';
import { PopupTerminalPickerProps } from '..';
import TerminalPicker from '../../../../assets/terminal-picker.png';
import { ModeEnterAddress } from './ModeEnterAddress';
import { ModeListAddress } from './ModeListAddress';
import { ModeListTerminal } from './ModeListTerminal';

export const PopupTerminalPickerMobile: React.FC<PopupTerminalPickerProps> = ({
  showPopup,
  onClosePopup,
}) => {
  const {
    locationGetDistanceTerminals,
    currentTerminals,
    setTemporaryDataDistanceTerminal,
    temporaryDataDistanceTerminal,
    modeTerminalPicker,
    currentTerminal,
  } = useDistanceTerminalContext();

  useEffect(() => {
    if (showPopup) {
      setTemporaryDataDistanceTerminal?.({
        ...temporaryDataDistanceTerminal,

        terminals:
          !!currentTerminals && Array.isArray(currentTerminals)
            ? currentTerminals
            : [],
        ...(locationGetDistanceTerminals
          ? { location: locationGetDistanceTerminals }
          : {}),
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTerminals, locationGetDistanceTerminals, showPopup]);

  return (
    <StyledBottomSheet
      show={showPopup}
      position={'bottom'}
      zIndex={2000}
      closeBottomSheet={currentTerminal ? onClosePopup : undefined}
      contentHeight="78vh"
      title={t('Chọn khu vực của bạn')}
    >
      <Flex
        padding="s16"
        direction="column"
        gap="s12"
        align="center"
        justify="center"
      >
        {modeTerminalPicker === MODE_TERMINAL_PICKER.LIST_TERMINAL && (
          <>
            <Shape paddingBottom="s16">
              <Image
                height="72px"
                width="116px"
                src={TerminalPicker}
                alt={t('Chọn khu vực của bạn')}
              />
            </Shape>
            <ModeListTerminal />
          </>
        )}
        {modeTerminalPicker === MODE_TERMINAL_PICKER.ENTER_ADDRESS && (
          <ModeEnterAddress />
        )}
        {modeTerminalPicker === MODE_TERMINAL_PICKER.LIST_ADDRESS && (
          <ModeListAddress />
        )}
      </Flex>
    </StyledBottomSheet>
  );
};

const StyledBottomSheet = styled(BottomSheet)`
  width: 100%;
`;
